import { render, staticRenderFns } from "./BlogSortableItem.vue?vue&type=template&id=25a54462&"
import script from "./BlogSortableItem.vue?vue&type=script&lang=js&"
export * from "./BlogSortableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports